var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", { staticStyle: { "text-align": "center" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm.code === 1
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/1.png") },
          })
        : _vm._e(),
      _vm.code === 2
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/2.png") },
          })
        : _vm._e(),
      _vm.code === 3
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/3.png") },
          })
        : _vm._e(),
      _vm.code === 4
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/4.png") },
          })
        : _vm._e(),
      _vm.code === 5
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/5.png") },
          })
        : _vm._e(),
      _vm.code === 6
        ? _c("img", {
            staticClass: "process-status-img",
            attrs: { src: require("../../../../assets/img/flowable/6.png") },
          })
        : _vm._e(),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.selectedTab,
            callback: function ($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "表单信息", name: "form-first" } },
            [
              _vm.formType === "2"
                ? _c(_vm.form, {
                    ref: "form",
                    tag: "component",
                    class: _vm.formReadOnly ? "readonly" : "",
                    attrs: {
                      formReadOnly: _vm.formReadOnly,
                      businessId: _vm.businessId,
                    },
                  })
                : _vm._e(),
              _vm.formType !== "2"
                ? _c("PreviewForm", {
                    ref: "form",
                    attrs: {
                      processDefinitionId: _vm.procDefId,
                      edit: false,
                      taskFormData: _vm.taskFormData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.procInsId
            ? _c(
                "el-tab-pane",
                { attrs: { label: "流程信息", name: "form-second" } },
                [
                  _c("flow-time-line", {
                    attrs: { historicTaskList: _vm.historicTaskList },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-tab-pane",
            { attrs: { label: "流程图", name: "form-third" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("流程图")])]
                  ),
                  _vm.procInsId
                    ? _c("flow-chart", {
                        ref: "chart1",
                        attrs: { processInstanceId: _vm.procInsId },
                      })
                    : _vm._e(),
                  !_vm.procInsId
                    ? _c("flow-chart", {
                        ref: "chart2",
                        attrs: { processDefId: _vm.procDefId },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.procInsId
            ? _c(
                "el-tab-pane",
                { attrs: { label: "流转记录", name: "form-forth" } },
                [
                  _c("flow-step", {
                    attrs: { historicTaskList: _vm.historicTaskList },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }